import DatasetDataSourceForm from 'scoreboard/datasets/dataset-data-source-form'
import _ from 'lodash'

const ReportDataSourceForm = DatasetDataSourceForm.extend({

	showDataset: false,
	allowPercentageAggregationType: false,
	showDecimalPrecision: false,
	showLabel: false,

	/**
	 * The data source form for a column in a dataset report. In addition to
	 * the options listed here, see the superclass for additional options
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {ReportModel} options.reportModel
	 */
	initialize: function(options = {}) {
		//dynamically determine if we need to show the aggregation types
		DatasetDataSourceForm.prototype.initialize.apply(this, arguments)
		this.reportModel = this.options.reportModel
		this.showAggregationType = this._showAggType.bind(this)
		this.allowCalculated = !this.options.isGrouping
	},

	_showAggType: function() {
		// for calculated we hide the aggregation type. A value is calculated
		// for each row so there's no need to aggregate anything
		if (this.dataSourceType() === 'basic') {
			let fieldIdentifier = this.getSelectedFieldIdentifier()
			return this.reportModel.requiresAggregationType(fieldIdentifier,
				{ column: this.options.dataSource })
		}
		return false
	},

	/**
	 * Determines whether filters are allowed. Business rules come from here:
	 * https://github.com/SpiderStrategies/Scoreboard/issues/50101#issuecomment-1268736659
	 */
	filtersAllowed: function() {
		if (!DatasetDataSourceForm.prototype.filtersAllowed.apply(this, arguments)) {
			return false
		}

		// Rule 1: regardless of whether the field is basic or calculated, the
		// data is aggregated, so it's fine to filter
		if (this.reportModel.isAggregating()) {
			return true
		}

		if (this.dataSourceType() === 'basic') {
			let fieldIdentifier = this.getSelectedFieldIdentifier()
			let columnData = this.reportModel._defaultColumnData(fieldIdentifier)
			let foreignFieldOnManySide = _.get(columnData,
				'foreignFieldOnManySide', false)
			// Rule 2a: Filters make sense if the dataset is on the "many" side
			// of a relationship with the main dataset for the report.
			return foreignFieldOnManySide
		} else {
			// Situation 2b: Calculated fields are currently not allowed to be
			// filtered.

			// We may want to change this in the future, but we haven't settled
			// on business rules, and as of right now we don't have a
			// requirement to allow this
			return false
		}
	},

	getStartingDatasetId: function() {
		return this.options.startingDatasetId
	},

	_getFieldOptions: function() {
		let dropdownOptions = DatasetDataSourceForm.prototype._getFieldOptions.apply(this, arguments)

		let {optionData} = this.options
		if (!_.isEmpty(optionData) && !_.isNil(optionData)) {
			let optionDataById = _.keyBy(optionData, 'id')
			dropdownOptions = _.filter(dropdownOptions, opt => !_.isNil(optionDataById[opt.id]))
		}
		return dropdownOptions
	},

	_renderFieldDropdownOptions: function() {
		return {
			includeTotal: true,
			includeNativeTotal: !this.options.isGrouping
		}
	},

	isHideAggregationTypeForSameDataset: function() {
		return !this.reportModel.isAggregating()
	}

})

export default ReportDataSourceForm

ReportDataSourceForm.__filename__ = 'reports/common/designer-data-source-form.js'
